import LocaleManager from '../utils/LocaleManager.js';
import Config from '../utils/Config.js';
import Utils from '../utils/Utils.js';
import StateButton from '../controls/StateButton.js';
import PopupManager from '../utils/PopupManager.js';
import SoundManager from '../utils/SoundManager.js';

export default class BonusSpinPopup extends Phaser.Group {
    constructor(game)
    {
        super(game);

        this.onClose = new Phaser.Signal();
        this.redraw();
    }

    redraw()
    {
        this.removeAll(true, true);
        const game = this.game;

        const bg = this._bg = new Phaser.Image(game, 0, 0, 'popups.bonus-spin.bg');
        this.addChild(bg);

        const close = new StateButton(game, 0, 0, 'buttons.accept', () =>
        {
            SoundManager.playSound('sounds/touch');
            this.onClose.dispatch();
        });
        this.addChild(close);

        const localeFontSettings = {
            'cs': {
                fontSize: {
                    [Config.DESKTOP]: 46,
                    [Config.LANDSCAPE]: 46,
                    [Config.PORTRAIT]: 40
                }
            },
            'de': {
                fontSize: {
                    [Config.DESKTOP]: 46,
                    [Config.LANDSCAPE]: 46,
                    [Config.PORTRAIT]: 40
                }
            },
            'el': {
                fontSize: {
                    [Config.DESKTOP]: 42,
                    [Config.LANDSCAPE]: 42,
                    [Config.PORTRAIT]: 40
                }
            },
            'es': {
                fontSize: {
                    [Config.DESKTOP]: 40,
                    [Config.LANDSCAPE]: 40,
                    [Config.PORTRAIT]: 40
                }
            },
            'fi': {
                fontSize: {
                    [Config.DESKTOP]: 44,
                    [Config.LANDSCAPE]: 44,
                    [Config.PORTRAIT]: 44
                }
            },
            'hu': {
                fontSize: {
                    [Config.DESKTOP]: 42,
                    [Config.LANDSCAPE]: 42,
                    [Config.PORTRAIT]: 42
                }
            },
            'is': {
                fontSize: {
                    [Config.DESKTOP]: 42,
                    [Config.LANDSCAPE]: 42,
                    [Config.PORTRAIT]: 42
                }
            },
            'lv': {
                fontSize: {
                    [Config.DESKTOP]: 36,
                    [Config.LANDSCAPE]: 36,
                    [Config.PORTRAIT]: 36
                }
            },
            'pl': {
                fontSize: {
                    [Config.DESKTOP]: 46,
                    [Config.LANDSCAPE]: 46,
                    [Config.PORTRAIT]: 46
                }
            },
            'pt': {
                fontSize: {
                    [Config.DESKTOP]: 60,
                    [Config.LANDSCAPE]: 60,
                    [Config.PORTRAIT]: 50
                }
            },
            'tr': {
                fontSize: {
                    [Config.DESKTOP]: 46,
                    [Config.LANDSCAPE]: 44,
                    [Config.PORTRAIT]: 44
                }
            },
        }[LocaleManager.locale] || {
            fontSize: {
                [Config.DESKTOP]: 60,
                [Config.LANDSCAPE]: 60,
                [Config.PORTRAIT]: 60
            }
        };

        const title = new Phaser.Text(game, 0, 0, LocaleManager.getString('popup_bonus_spin.title'), {
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize: localeFontSettings.fontSize[Config.layout],
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: bg.width - 60,
            align: 'center'
        });
        title.anchor.set(0.5);
        this.addChild(title);

        const line1 = new Phaser.Text(game, 0, 0, LocaleManager.getString('popup_bonus_spin.message-line1'), {
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize: 20,
            fill: '#D9B869'
        });
        line1.anchor.set(0.5, 0);
        this.addChild(line1);

        const line2Container = new Phaser.Group(game, this);

        const count = this._count = new Phaser.Text(game, 0, 0, '20', {
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize: 34,
            fill: '#FFFFFF'
        });
        count.anchor.set(1, 1);
        line2Container.addChild(count);

        const line2 = new Phaser.Text(game, 0, 0, LocaleManager.getString('popup_bonus_spin.message-line2'), {
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize: 24,
            fill: '#FFFFFF'
        });
        line2.anchor.set(0, 1);
        line2.position.set(10, -3);
        line2Container.addChild(line2);

        /* SET POSITIONS */

        line1.position.set(bg.width >> 1, 98);

        line2Container.position.set(
            (bg.width - line2Container.width >> 1) - line2Container.getLocalBounds().x,
            line1.y + line1.height - line2Container.getLocalBounds().y - (Config.layout === Config.PORTRAIT ? 12 : 16)
        );

        title.position.set(
          (bg.width >> 1) + (Config.layout === Config.PORTRAIT ? 0 : 5),
          line2Container.y + line2Container.height - 16
        );

        close.position.set(
          bg.width - close.width >> 1,
          bg.height - close.hitArea.height - 42
        );

        if (this._showArguments)
        {
            this.show.apply(this, this._showArguments);
        }
    }

    show(count = 0)
    {
        this._count.text = count;

        if (SoundManager.sound && !this._showArguments)
        {
            SoundManager.playSound('sounds/bonus-spins', false, true);
        }

        this._showArguments = arguments;
    }

    alignToWorld()
    {
        this.position.set(
            Config.GAME_WIDTH - this.width >> 1,
            (Config.GAME_HEIGHT - this.height >> 1) - 20
        );
    }
}